var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDvrNvr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2537",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.902,
    height: 23.692,
    viewBox: "0 0 24.902 23.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 893",
    d: "M843.4 88.282a.6.6 0 0 1 .325.609q-.006 6.506 0 13.013c0 .462-.143.6-.61.6H819.44c-.467 0-.61-.14-.61-.6V88.891a.6.6 0 0 1 .325-.609zm-12.128.445h-11.328c-.545 0-.671.125-.671.669v12c0 .543.125.666.674.666h22.666c.546 0 .671-.125.671-.669v-12c0-.542-.126-.666-.674-.666z",
    transform: "translate(-818.827 -88.282)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 894",
    d: "M831.306 421.517h-11.779c-.532 0-.657-.123-.658-.654v-4.034c0-.508.141-.649.644-.649h23.607c.5 0 .645.14.645.648v4.058c0 .5-.135.631-.632.631zm-4.881-.89h6.088c.43 0 .584-.153.585-.579v-2.351c0-.474-.149-.627-.618-.627h-12.1c-.474 0-.62.146-.621.622v2.3c0 .5.135.634.629.634zm14.237-2.657a1.327 1.327 0 1 0 2.655-.016 1.327 1.327 0 1 0-2.655.016zm-4.013-.888h-.865v.856h.865zm.91.861h.857v-.858h-.857zm-.909 1.814h-.867v.849h.867zm.914-.007v.864h.855v-.864z",
    transform: "translate(-818.866 -399.605)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 895",
    d: "M1026.965 362.732v-2.184h1.758v2.184z",
    transform: "translate(-1015.397 -346.241)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 896",
    d: "M869.186 528.4h1.514c-.065.268-.121.523-.192.774a.181.181 0 0 1-.134.1c-.319.009-.639 0-.971 0z",
    transform: "translate(-866.387 -505.587)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 897",
    d: "M1189.225 528.409h1.517l-.22.88h-.968a.182.182 0 0 1-.136-.1c-.072-.256-.128-.512-.193-.78z",
    transform: "translate(-1168.639 -505.598)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 898",
    d: "M843.15 117.925v-5.3h10.639v5.3z",
    transform: "translate(-841.798 -111.27)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 899",
    d: "M1061.818 117.959h-10.635v-5.307h10.635z",
    transform: "translate(-1038.269 -111.298)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 900",
    d: "M843.073 229.9v-5.3h10.64v5.3z",
    transform: "translate(-841.726 -217.022)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 901",
    d: "M1061.672 229.983h-10.646v-5.3h10.646z",
    transform: "translate(-1038.121 -217.104)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 902",
    d: "M862.635 448.547v1.741h-11.541v-1.741z",
    transform: "translate(-849.301 -430.174)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 903",
    d: "M1227.47 440.294a.445.445 0 0 1 .432.446.435.435 0 1 1-.869-.008.441.441 0 0 1 .437-.438z",
    transform: "translate(-1204.345 -422.379)",
    style: {
      fill: "#6150d1",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvrNvr);
export default __webpack_public_path__ + "static/media/dvr-nvr.3aec5541ebc913284ac3eca225c48b60.svg";
export { ForwardRef as ReactComponent };